
























import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { 
  JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW,
  APPLICATION_ALERT_STATUS_TEXT
} from './../MyJobs/MyJobsConstants';

@Component({
  components: {},
})
export default class JobIntermediateStep extends Vue {

  public INTERVIEW_SUB_STATUS_COMPLETED ='Completed';
  public INTERVIEW_SUB_STATUS_CANCELLED = 'Cancelled';

  @Prop() job_;
  $moment: any;

   showHeader() {
    if (!this.job_) return '';
    const status = this.getJobPostingAssignmentAlertStatusText();
    return typeof status === 'string' && status.length > 0;
  }

  showInterviewSlot() {
    return( 
      this.job_.subStatusDescription !== this.INTERVIEW_SUB_STATUS_COMPLETED &&
      this.job_.subStatusDescription !== this.INTERVIEW_SUB_STATUS_CANCELLED );
  }

  nextStep() {
    vxm.jobs.setJobAdminMessage(this.job_.adminComment); 
    this.$router.push({ name: 'myjobstatusWorkflowStep', params: { JobID: this.job_.jobPostingId }  })
  }
  
  
  get showMessage() : string {
    const statusText = this.getJobPostingAssignmentAlertStatusText();
    if(this.job_.awaitingActionBy && this.job_.awaitingActionBy === '01' && this.job_.nextStepScheduleStartDTTM) {
      var n = this.job_.nextStepScheduleStartDTTM.substring(this.job_.nextStepScheduleStartDTTM.indexOf("T"));
      var res = n.replace(/-/g, ":");
      this.job_.nextStepScheduleStartDTTM = this.job_.nextStepScheduleStartDTTM.replace(n, res);

      const startDTTM =new Date(this.job_.nextStepScheduleStartDTTM);
      const dateString = this.$moment(startDTTM).format('DD-MMM-YYYY');
      const timeStampString = this.$moment(startDTTM).format('hh:mm A');
      return this.job_.jobPostingAssignmentStatus === JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW
        ? `Your interview is scheduled on ${dateString} at ${timeStampString}`
        : `${statusText}, and you’ve been selected for an interview scheduled on ${dateString} at ${timeStampString}`;
    }
    else {
      const isInterviewStatus = this.job_.jobPostingAssignmentStatus === JOBPOSTING_ASSIGNMENT_STATUS_INTERVIEW;
      return this.job_.hasScheduledInterviews && !isInterviewStatus
        ? `${statusText}, and you’ve been selected for an interview`
        :statusText;
    }
  }

  getJobPostingAssignmentAlertStatusText() : string {
    const translatedStatus = { 
      '20': this.$t('MyJobIntermediateStep_ApplicationScreened').toString(),
      '30': this.$t('MyJobIntermediateStep_SelectedForInterview').toString(),
      '35': this.$t('MyJobIntermediateStep_ApplicationReviewed').toString()
    };
    return translatedStatus[this.job_.jobPostingAssignmentStatus] ||
    	this.$t(APPLICATION_ALERT_STATUS_TEXT[this.job_.jobPostingAssignmentStatus]) || '';
  }

}
